const FormGroup = ({ label, name, children, showError, externalErrorMessage, noWrapLabel, required }) => {
    return (
        <div className="form-group">
            <label className="body-1b" htmlFor={name} style={{ textWrap: noWrapLabel ? 'nowrap' : 'inherit' }}>
                {label}
                {required ? <span className="required"> *</span> : ''}
            </label>
            {children}
            <p className="field-error" id={`${name}-error`}>
                {showError && externalErrorMessage}
            </p>
        </div>
    );
};

export default FormGroup;
